import { useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames, TextArea } from '@opallabs/kuiper'
import {
  Module,
  OnDragDropProps,
  OnShowAssetPickerProps,
} from '@opallabs/periodic/src/Content/helpers/types'
import { SingleAssetPicker } from '@opallabs/periodic/src/SingleAssetPicker'
import { FacebookStoryFooter } from '../../FacebookStoryFooter'
import { FacebookStoryHeader } from '../../FacebookStoryHeader'
import { styles } from './styles'

type MobileSingleProps = {
  accountImage: AssetReference
  accountName: string
  collabEnabled?: boolean
  collabAccount?: string
  fbStoryAllowReplies: boolean
  fbStoryAllowSharing: boolean
  isDragging: boolean
  isPresenting: boolean
  content: string
  index: number
  modules: Module[]
  assets: AssetReference[]
  onDragDrop: OnDragDropProps
  onExpandAsset: (id: number) => void
  onRemoveAsset: (id: number, index: number) => void
  onShowAssetPicker: (args: OnShowAssetPickerProps) => void
  readOnly: boolean
  updateText: (val: string, dest: string) => void
}

export const MobileSingle: React.FC<MobileSingleProps> = ({
  accountImage,
  accountName,
  collabEnabled,
  collabAccount,
  fbStoryAllowReplies,
  fbStoryAllowSharing,
  isDragging,
  isPresenting,
  content,
  index,
  assets,
  modules,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  readOnly,
  updateText,
}) => {
  const asset = assets && assets.length ? assets[0] : null
  const [isHovering, setIsHovering] = useState(false)

  return (
    <div
      css={styles.facebookStoryWrapper}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {asset && (
        <FacebookStoryHeader
          index={index}
          sections={modules}
          accountName={accountName}
          accountImage={accountImage}
          collabEnabled={collabEnabled}
          collabAccount={collabAccount}
        />
      )}
      <div css={styles.assetWrapper}>
        {asset ? (
          <div css={styles.assetStyle}>
            <Asset
              imageFit="cover"
              assetReference={asset}
              placeholder={false}
              isHovered={isHovering}
              hasAssetOverlay={asset && (!readOnly || isPresenting)}
              removeable={!readOnly}
              overrideStyles={{
                assetBase: styles.getAssetBaseStyle(asset.asset_type || ''),
                asset: styles.getAssetBaseStyle(asset.asset_type || ''),
              }}
              onEmbiggen={() => onExpandAsset(asset.id || 0)}
              onRemove={() => onRemoveAsset(asset.id || 0, index)}
            />
          </div>
        ) : (
          <SingleAssetPicker
            allowedUploadTypes={1000}
            disableDrop={isDragging}
            onDragDrop={(e) =>
              onDragDrop(e, {
                destination: 'carousel',
                index,
                allowMultiple: 1000,
              })
            }
            onShowAssetPicker={() =>
              onShowAssetPicker({
                destination: 'carousel',
                index,
                allowMultiple: 1000,
              })
            }
            readOnly={readOnly}
            style={{ height: 667, width: 375 }}
          />
        )}
        {!(readOnly && !content) && (
          <div
            className={kuiperClassNames('asset-carousel-content-textarea')}
            css={styles.contentWrapperStyle}
          >
            <TextArea
              minRows={1}
              placeholder={'Add content...'}
              value={content || ''}
              style={styles.contentStyle}
              readOnly={readOnly}
              onChange={(val: string) => updateText(val, 'content')}
            />
          </div>
        )}
      </div>
      {asset && (
        <FacebookStoryFooter
          index={index}
          sections={modules}
          repliesEnabled={fbStoryAllowReplies}
          sharingEnabled={fbStoryAllowSharing}
        />
      )}
    </div>
  )
}
